import moralis from 'moralis-v1'

export default moralis
